module.exports = __webpack_public_path__ + "static/media/arpad_loboda.874b5ac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/doctors/arpad_loboda.jpg
// module id = 428
// module chunks = 0